/**
 * StaffManagementContainer
 * --
 */
import React, { useEffect, useState } from 'react';
import StaffManagementPresenter from './StaffManagementPresenter';
import {
  useGetStaffs,
  useCreateStaff,
  useUpdateStaff,
  useDeleteStaff,
} from 'hooks/StaffHooks';
import { LoadingPage } from 'components';
import Formatter from 'utils/Formatter';
import MessageAlert from 'utils';
// import moment from 'moment';
import { useUserStack } from 'store';

const StaffManagementContainer = () => {
  /* ===== ROUTE ===== */

  /* ===== Data ===== */
  // 주문 전체 조회
  const { data: Staff, refetch: refetchStaffs } = useGetStaffs();

  /* ===== PROPS ===== */
  /* ===== Mutate ===== */
  const userInfo = useUserStack();
  const { createStaff } = useCreateStaff();
  const { updateStaff } = useUpdateStaff();
  const { deleteStaff } = useDeleteStaff();
  /* ===== STATE ===== */
  const [selectedItem, setSelectedItem] = useState({});
  const [isRefetch, setIsRefetch] = useState(false);

  const [data, setData] = useState([]);

  // 모달 open 여부
  const [isOpened, setIsOpened] = useState(false);
  // 모달 타입
  const [modalType, setModalType] = useState('');
  // 메뉴 파일
  // const [files, setFiles] = useState([]);

  const [modalData, setModalData] = React.useState({});

  // 로딩
  const [isLoading, setIsLoading] = React.useState(false);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 모달 핸들러
   * --
   */
  const handleModal = (open, type = '', data = {}) => {
    setModalData((prev) => ({
      ...prev,
      [type]: data,
    }));
    setIsOpened(!open);
    setModalType(type);
  };

  /**
   * 데이터 바인딩 함수
   * --
   * @param {string} target
   * @param {*} value
   * @param {object} object
   * @param {*} callback
   */
  const handleChange = (t, v, o, callback = null) => {
    let newData = modalData[o];

    newData[t] = v;
    const d = {
      ...modalData,
      o: { ...newData },
    };

    setModalData(d);
  };

  const handleSubmit = async (t, s = 'CREATE') => {
    const type = t.toLocaleUpperCase();
    const submit = s.toLocaleUpperCase();

    const submitType = {
      STAFF: '직원',
      CREATE: '생성',
      UPDATE: '수정',
    };

    const data = handleValidateCheck(type);
    if (!data) return;

    const submitFunc = {
      STAFF: {
        CREATE: createStaff,
        UPDATE: updateStaff,
      },
    };

    try {
      // 로딩 처리
      setIsLoading(true);

      // 데이터 생성/수정
      const { status } = await submitFunc[type][submit]({
        shop_information_id: userInfo?.shop_information_id,
        ...data,
      });

      // 데이터 업데이트 성공 시
      if (status === 200) {
        MessageAlert.success(
          `성공적으로 ${submitType[type]}이/가 ${submitType[submit]}되었습니다.`
        );
        // 값 초기화
        setSelectedItem((prev) => ({ ...prev, t: {} }));
        setModalData((prev) => ({ ...prev, t: {} }));
        setIsOpened(false);
        setIsRefetch(true);

        return;
      }

      MessageAlert.warning(
        `${submitType[type]}을/를 ${submitType[submit]}하는데 실패하였습니다.`
      );
    } catch (err) {
      MessageAlert.error(
        `${submitType[type]}을/를 ${submitType[submit]}하는데 오류가 발생하였습니다.`
      );
      console.error(`[CREATE ${type}] ERROR : `, err);
      throw err;
    } finally {
      // 로딩 처리
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  };

  /**
   * 유효성 검사
   * --
   * @param {string} t
   * @returns
   */
  const handleValidateCheck = (t) => {
    if (t === 'STAFF') {
      // 직원 유효성 검사
      console.log(modalData?.staff);
      const {
        staff_name,
        staff_phone,
        birthday,
        hire_date,
        termination_date,
        staff_gender,
      } = modalData?.staff;

      // 직원명 입력값 체크
      if (!staff_name) {
        MessageAlert.warning('직원명을 입력해주세요.');
        return false;
      }

      // 연락처 입력 시 유효성 검사
      if (staff_phone && staff_phone.length < 11) {
        MessageAlert.warning('잘못된 연락처 형식입니다.');
        return false;
      }

      return {
        ...modalData?.staff,
        birthday: birthday ? Formatter.dateToUnix(birthday) : null,
        hire_date: hire_date ? Formatter.dateToUnix(hire_date) : null,
        termination_date: termination_date
          ? Formatter.dateToUnix(termination_date)
          : null,
        staff_gender: staff_gender ? staff_gender : 'M',
      };
    }
  };
  /**
   * 선택 삭제
   * --
   */
  const handleDeleteSelected = async (t = 'STAFF', v) => {
    setIsLoading(true);
    try {
      const type = t.toLocaleUpperCase();
      const method = {
        STAFF: {
          DELETE: deleteStaff,
          VALUE: v,
          MESSAGE: '직원',
          ERROR_MESSAGE: '삭제를 실패했습니다. 다시 시도해주세요.',
        },
      };
      const { status } = await method[type].DELETE(method[type].VALUE);

      if (status === 200) {
        MessageAlert.success(`${method[type].MESSAGE}이 삭제처리 되었습니다.`);
        refetchStaffs();
        setIsRefetch(true);
      } else {
        MessageAlert.error(method[type].ERROR_MESSAGE);
      }
    } catch (err) {
      MessageAlert.error('삭제를 실패 했습니다. 다시 시도해주세요');
      console.error('[DELETE EVENT ERROR]:', err);
    } finally {
      setIsLoading(false);
    }
  };
  /* ===== HOOKS ===== */
  /**
   * 데이터 초기화
   * --
   */
  useEffect(() => {
    const newData = Staff?.data.filter(
      (staff) => staff?.shop_information_id === userInfo?.shop_information_id
    );
    setData(newData);
    // eslint-disable-next-line
  }, [Staff]);

  // console.log(selectedItem);
  // console.log(modalData);
  /* ===== RENDER ===== */
  return (
    <>
      {isLoading && (
        <LoadingPage text={'데이터를 처리중입니다. 잠시만 기다려주세요.'} />
      )}
      <StaffManagementPresenter
        data={data}
        selectedItem={selectedItem}
        isOpened={isOpened}
        modalType={modalType}
        modalData={modalData}
        // files={files}
        isRefetch={isRefetch}
        onSelect={setSelectedItem}
        onOpen={handleModal}
        onSubmit={handleSubmit}
        onDelete={handleDeleteSelected}
        onChange={handleChange}
        setIsRefetch={setIsRefetch}
      />
    </>
  );
};

export default StaffManagementContainer;
